export const CLUE_VALUES = [200, 400, 600, 800, 1000];